import "./cart.scss";
import { Link } from "react-router-dom";
import { useCallback, useState } from "react";
import { translateText } from "./../article/article";
import useCart from "../../hooks/useCart";
import { itemPreis, isRabatt, isAbholung, Footer } from "./cart";
const math = require("mathjs");

export default function Overview(props) {
  const { onNext } = props;

  const cart = useCart();

  const initNewsletterCheck = JSON.parse(
    window.sessionStorage.getItem("newsletter"),
  );

  const [checkNewsletter, setCheckNewsletter] = useState(initNewsletterCheck);

  const handleChangeNewsletter = () => {
    setCheckNewsletter(!checkNewsletter);
    window.sessionStorage.setItem("newsletter", !checkNewsletter);
  };

  const [checkAGB, setCheckedAGB] = useState(false);

  const deleteAll = useCallback(() => {
    cart.clear();
  }, [cart]);

  const deleteItem = useCallback(
    (currentItem) => {
      cart.delete(currentItem);
    },
    [cart],
  );

  const addAmount = useCallback(
    (currentItem) => {
      const itemAmount = cart.getAmount(currentItem);
      if (
        currentItem.anzahl &&
        currentItem.currentlySold + itemAmount + 1 > currentItem.anzahl
      ) {
        return;
      }
      cart.setAmount(currentItem, (n) => n + 1);
    },
    [cart],
  );

  const removeAmount = (currentItem) => {
    cart.setAmount(currentItem, (n) => n - 1);
  };

  cart.items.sort((x, y) => {
    var n = math.subtract(x.order, y.order);
    if (n !== 0) {
      return n;
    }
    return ("" + x.size).localeCompare(y.size);
  });

  return (
    <>
      <div className="CartHeader">
        <h3 className="Heading">Warenkorb</h3>
        <h5 onClick={(e) => deleteAll()} className="Action">
          alles löschen
        </h5>
      </div>
      {cart.items.map((item) => {
        const preis = itemPreis(item);
        const itemAmount = math.multiply(item.amount, preis);
        const itemKey = [item.id, item.option, item.size].join("~");
        return (
          <div key={itemKey} className="Cart-Items">
            <div className="image-box">
              {item?.bilder?.data?.length > 0 && (
                <img
                  alt={item.name + "image"}
                  src={item.bilder.data[0]?.attributes?.formats?.small?.url}
                />
              )}
            </div>
            <div className="about">
              <h1 className="title">
                <Link to={"/shop/artikel/" + item.id}>{item.name}</Link>
              </h1>
              <h3 className="subtitle">
                {translateText(item.subType1)}
                {translateText(item.subType2)
                  ? ` | ${translateText(item.subType2)}`
                  : ""}
                {translateText(item.subType3)
                  ? ` | ${translateText(item.subType3)}`
                  : ""}{" "}
                {item.amountCamper ? `Camperplätze: ${item.amountCamper} ` : ""}
                {item.amountTent ? `Zeltplätze: ${item.amountTent} ` : ""}
                {item.size
                  ? `Größe: ${item.size.toUpperCase() === "XXL" ? "2XL" : item.size.toUpperCase() === "XXXL" ? "3XL" : item.size.toUpperCase() === "XXXXL" ? "4XL" : item.size.toUpperCase()} `
                  : ""}
                {item.option ? `Option: ${item.option} ` : ""}
              </h3>
            </div>
            <div className="counter-prices-container">
              <div className="counter">
                <div onClick={(e) => removeAmount(item)} className="btn">
                  -
                </div>
                <div className="count">{item.amount}</div>
                <div onClick={(e) => addAmount(item)} className="btn">
                  +
                </div>
              </div>
              <div className="prices">
                <div className="amount">{itemAmount.toFixed(2)} €</div>
                {isRabatt() && item.mitgliederRabat && (
                  <div className="rabat">inklusive 20% Mitgliedsrabatt </div>
                )}
                <div onClick={(e) => deleteItem(item)} className="remove">
                  <u>löschen</u>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <hr />
      <div className="checkout">
        <div className="total">
          {!isAbholung() && cart.hasShipping() && (
            <>
              <div>
                <div className="shipping">Versand</div>
              </div>
              <div className="cost-amount">
                {cart.getShippingCost().toFixed(2)} €
              </div>
            </>
          )}
        </div>
        <div className="total">
          <div>
            <div className="Subtotal">Summe</div>
            <div className="items">{cart.getTotalAmount()} Artikel</div>
          </div>
          <div className="total-amount">
            {math
              .add(math.number(cart.getTotal(itemPreis)), math.number(cart.getShippingCost()))
              .toFixed(2)}{" "}
            €
          </div>
        </div>
        <div className="agbContainer">
          <input
            type="checkbox"
            id="checkAGB"
            checked={checkAGB}
            onChange={() => setCheckedAGB(!checkAGB)}
          />
          <label htmlFor="checkAGB">
            Hiermit bestätige ich die{" "}
            <a href="/agb" target="_blank">
              AGB
            </a>
          </label>
        </div>
        <div className="agbContainer">
          <input
            type="checkbox"
            id="checkNewsletter"
            checked={checkNewsletter}
            onChange={handleChangeNewsletter}
          />
          <label htmlFor="checkNewsletter">
            Ich möchte den Newsletter erhalten.
          </label>
        </div>
      </div>
      <Footer disabled={!checkAGB} onNext={onNext} />
    </>
  );
}
